import { useEffect } from 'react';

import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import find from 'lodash/find';

import { subscriptionCategories } from 'constants/subscriptions';

import {
  getSkincareTexturesDetails,
  getSkincareTexturesError,
  getSkincareTexturesStatus,
} from 'dux/consultation/selectors';
import { fetchSkincareTextures } from 'dux/consultation/thunks';

const useGetSkincareTexturesByProductSlug = ({ productSlug, category }) => {
  const dispatch = useDispatch();
  const status = useSelector(getSkincareTexturesStatus);
  const detailedTexturesByproductSlug = useSelector(getSkincareTexturesDetails);
  const error = useSelector(getSkincareTexturesError);
  const textures = find(detailedTexturesByproductSlug, { skeleton_type: productSlug });
  const recommendedTexture = textures?.ranked_skeletons.find(
    texture => texture.is_recommended === true
  );

  const fetchTextures = () => dispatch(fetchSkincareTextures());

  useEffect(() => {
    if (category === subscriptionCategories.SKINCARE) {
      fetchTextures();
    }
  }, []);

  return { error, fetchTextures, textures, status, recommendedTexture };
};

export default useGetSkincareTexturesByProductSlug;
